import type { UserAPI } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import type { Route } from '@sydle/ui-utils';
import { getConfig, getRouteById, getRouteByIdentifier, urlFor } from '@sydle/ui-utils';
import type { ActionResult, Commands, Context, IndexedParams, Router } from '@vaadin/router';
import type { UIAppConfig } from '../types/ui-app-config';

type LastPageParams = {
  name: string;
  params: IndexedParams;
  search: string;
  hash: string;
};

export async function validateAccess(context: Context, commands: Commands, router: Router): Promise<ActionResult> {
  const uiAppConfig = getConfig<UIAppConfig>('ui-app');
  const authRouteIdentifier = uiAppConfig?.authRoute as string;
  if (!authRouteIdentifier) return;

  const authRoute = getRouteByIdentifier(authRouteIdentifier);

  const currentRouteId = (context.route as Route).routeId;
  if (!currentRouteId) return;

  const isLoggedIn = getAPI<UserAPI>('userAPI')?.getUser();
  if (isLoggedIn) {
    if (currentRouteId !== authRoute?._id) return;

    const redirectRouteIdentifier = uiAppConfig?.redirectRoute as string;
    if (!redirectRouteIdentifier) return;

    const path = urlFor(redirectRouteIdentifier, undefined, router);
    const normalizedPath = path.replace(router.baseUrl, '');

    return commands.redirect(normalizedPath);
  }

  const currentRoute = getRouteById(currentRouteId);
  if (!currentRoute?.authGuard) return;

  const lastPage: LastPageParams = {
    name: context.route.name,
    params: context.params,
    search: context.search,
    hash: context.hash,
  };

  sessionStorage.setItem('lastPage', JSON.stringify(lastPage));

  return commands.redirect(authRoute?.path as string);
}
